import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google/dist';
import { defaultNotifier } from 'functions/notificationHandler';
import { VuiButton } from '@topkamera/viso-ui';

const GOOGLE_CLIENT_ID_KEY = process.env.GOOGLE_CLIENT_ID_KEY || '';

const GoogleButton = () => {
  const clientId = GOOGLE_CLIENT_ID_KEY;

  const onGoogleLogin = () => {
    if (!clientId) {
      return defaultNotifier('Google client ID is not configured');
    }
    if (!window.google) {
      return defaultNotifier('Google SDK is not loaded yet');
    }
    try {
      const client = window.google.accounts.oauth2.initCodeClient({
        client_id: clientId,
        scope: 'openid email profile',
        ux_mode: 'redirect',
        redirect_uri: `${window.location.origin}/viso-sso/google`,
      });
      client.requestCode();
    } catch (e) {
      defaultNotifier('Login with Google failed');
    }
  };

  // if (!clientId) return null;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <VuiButton
        onClick={onGoogleLogin}
        color='white'
        style='filled'
        radius='pill'
        label='Google'
        iconLeft='googleLogo'
        isBlock
      />
    </GoogleOAuthProvider >
  );
};

export default GoogleButton;